import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import './Navbar.css';

function NavbarPL() {
  const { toggleLanguage } = useLanguage();

  const handleLanguageChange = (e) => {
    toggleLanguage(e.target.value);
  };

  return (
    <header className="navbar">
      <div className="navbar-left">
        <h1>Joanna Slawinska</h1>
        <p>+48 792 906 215</p>
      </div>
      <nav className="navbar-right">
        <NavLink
          to="/"
          end
          className={({ isActive }) => (isActive ? 'active-link' : '')}
        >
          Start
        </NavLink>
        <NavLink
          to="/work"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
        >
          Projekty
        </NavLink>
        <NavLink
          to="/about"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
        >
          O mnie
        </NavLink>
        <NavLink
          to="/cv"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
        >
          CV
        </NavLink>
        <NavLink
          to="/email"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
        >
          Kontakt
        </NavLink>
        <select 
          aria-label="Przełącznik języka" 
          onChange={handleLanguageChange}
          value="pl"
        >
          <option value="en">EN</option>
          <option value="pl">PL</option>
        </select>
      </nav>
    </header>
  );
}

export default NavbarPL; 